export default __webpack_public_path__ + "f0e3eea3e81b274e8cb1a1575ad16713.png";